export const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 12,
    borderColor: state.isFocused
      ? 'rgba(111, 225, 204, 0.8)'
      : 'rgba(255, 255, 255, 0.24)',
    backgroundColor: 'rgba(11, 9, 19, 0.8)',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(111, 225, 204, 0.2)' : 'none',
    ':hover': {
      borderColor: 'rgba(111, 225, 204, 0.8)',
    },
  }),
  singleValue: base => ({
    ...base,
    color: '#fef8f2',
  }),
  placeholder: base => ({
    ...base,
    color: '#d7ccdd',
  }),
  input: base => ({
    ...base,
    color: '#fef8f2',
  }),
  menu: base => ({
    ...base,
    backgroundColor: '#191629',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: 12,
    overflow: 'hidden',
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? '#120d14' : '#fef8f2',
    backgroundColor: state.isSelected
      ? '#ffb476'
      : state.isFocused
        ? 'rgba(255, 180, 118, 0.2)'
        : '#191629',
    cursor: 'pointer',
  }),
  multiValue: base => ({
    ...base,
    backgroundColor: 'rgba(255, 180, 118, 0.22)',
    border: '1px solid rgba(255, 255, 255, 0.22)',
  }),
  multiValueLabel: base => ({
    ...base,
    color: '#ffe5ca',
  }),
  multiValueRemove: base => ({
    ...base,
    color: '#ffe5ca',
    ':hover': {
      backgroundColor: 'rgba(239, 90, 103, 0.5)',
      color: '#fff7f9',
    },
  }),
  indicatorSeparator: base => ({
    ...base,
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? '#8de8d8' : '#ffe5ca',
    ':hover': {
      color: '#8de8d8',
    },
  }),
  clearIndicator: base => ({
    ...base,
    color: '#ffd8a1',
    ':hover': {
      color: '#ff9ca6',
    },
  }),
};
